import { useCallback } from 'react';
import { useNavigate } from 'react-router';
import { routes } from 'routes/routes';

export const useNavigateToMemberProfile = () => {
  const navigate = useNavigate();

  return useCallback(
    async (userId: string) => {
      await navigate(routes.members.detail(userId), { replace: true });
    },
    [navigate],
  );
};
